import Vue from 'vue'
import About from './About.vue'
import router from './router'
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import AnimateCss from 'animate.css';
Vue.use(AnimateCss);

import api from '../../../request/api' // 自定义全局请求
Vue.prototype.$api = api;

import '../../../assets/font/myFont.css'

import '../../../assets/css/vue2editor.css'

new Vue({
    router,
    render: h => h(About),
}).$mount('#about')